enum UserRole {
    OWNER = "owner",
    ADMIN = "admin",
    EDITOR = "editor",
    READER = "reader",
    GUEST = "guest",
    PENDING = "pending",
    REFUSED = "refused"
}

export default UserRole;
